// React
import React from "react";
import { render } from "react-dom";
// App
import Portal from "./Portal";

render(<Portal />, document.getElementById("root"));
